<template>
  <div id="ContactView">
    <v-card outlined>
      <v-card-title>{{ $t("vendor.headerStep4") }}</v-card-title>
      <v-card-text>
        <div class="general-viwe-layout">
          <h4>{{ $t("vendor.companyContactPoint") }}</h4>
          <p>{{ registerModel.companyContactPoint }}</p>
          <h4>{{ $t("vendor.tel") }}</h4>
          <p>{{ registerModel.companyContactPointTel }}</p>
          <h4>{{ $t("vendor.email") }}</h4>
          <p>{{ registerModel.companyToEmail }}</p>
          <h4>{{ $t("vendor.companyCcEmail") }}</h4>
          <p>{{ registerModel.companyCcEmail }}</p>
          <h4>{{ $t("vendor.gulfContactPoint") }}</h4>
          <p>{{ registerModel.gulfContactPointName }}</p>
          <h4>{{ $t("vendor.others") }}</h4>
          <p>{{ registerModel.others }}</p>
        </div></v-card-text
      ></v-card
    >
  </div>
</template>

<script>
export default {
  name: "ContactView",
  props: {
    propModel: {
      type: Object,
      require: true,
      default: () => {},
    },
    propsGulfContactPoint: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      registerModel: {},
    };
  },
  watch: {
    propModel(value) {
      if (!this.isEmpty(value)) {
        this.checkNull(value);
      }
    },
  },
  mounted() {
    if (!this.isEmpty(this.propModel)) {
      this.checkNull(this.propModel);
    }
  },
  methods: {
    checkNull(obj) {
      Object.keys(obj).forEach(function (key) {
        if (obj[key] === "") {
          obj[key] = "—";
        }
      });

      const resDate = obj.companyEstablishDate.substring(0, 10);
      obj.companyEstablishDate = resDate;
      this.registerModel = obj;
    },
    isEmpty(obj) {
      for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(prop)) {
          return false;
        }
      }
      return JSON.stringify(obj) === JSON.stringify({});
    },
  },
};
</script>

<style lang="scss" scoped>
.general-viwe-layout {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1rem;
  row-gap: 0.7rem;
  @media only screen and (min-width: 600px) {
    grid-template-columns: 1fr;
  }
  @media only screen and (min-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  > h1 {
    font-size: 18px;
    margin-bottom: 1.5rem;
    grid-column: 1/2;
    @media only screen and (min-width: 600px) {
      grid-column: 1/3;
    }
  }
  > h4 {
    color: #103a5d;
    font-weight: 500;
    grid-column: 1/2;
    font-size: 14px;
    margin: 0;
    > span {
      color: red;
    }
    @media only screen and (min-width: 600px) {
      grid-column: 1/2;
    }
  }
  > p {
    color: #555555;
    margin: 0;
  }
  > a {
    color: #555555;
  }
  > .line {
    grid-column: 1/2;
    border-bottom: 1px solid #e5e5e5;
    @media only screen and (min-width: 600px) {
      grid-column: 1/3;
    }
  }
  > .full {
    grid-column: 1/2;
    display: grid;
    grid-template-columns: 5rem 1fr;
    @media only screen and (min-width: 600px) {
      grid-column: 1/3;
    }
    > h4 {
      color: #103a5d;
      font-weight: 500;
      grid-column: 1/2;
      font-size: 14px;
      margin: 0;
      > span {
        color: red;
      }
      @media only screen and (min-width: 600px) {
        grid-column: 1/2;
      }
    }
    > p {
      color: #555555;
      margin: 0;
      > span {
        color: #103a5d;
      }
    }
  }
}
</style>
